module.exports = __webpack_public_path__ + "static/media/img182.81410632.jpg";